import { render, staticRenderFns } from "./BaseCollapseBlockButton.vue?vue&type=template&id=90e355d2&scoped=true&"
import script from "./BaseCollapseBlockButton.vue?vue&type=script&lang=js&"
export * from "./BaseCollapseBlockButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseCollapseBlockButton.vue?vue&type=style&index=0&id=90e355d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e355d2",
  null
  
)

export default component.exports